export default __webpack_public_path__ + "static/media/Screenshot_4.640c89b6.jpg";